import React, { Component } from "react";
import "./TechCareerComponent.css";
import DataScienceImg from "../../../containers/skills/DataScienceImg";
import CodeReview from "../../../containers/skills/CodeReview";
import FullStackImg from "../../../containers/skills/FullStackImg";
import DesignImg from "../../../containers/skills/DesignImg";
import CloudInfraImg from "../../../containers/skills/CloudInfraImg";
import { Fade } from "react-reveal";
import { articlesContent } from "../../../portfolio";
import SoftwareSkill from "../../../components/softwareSkills/SoftwareSkill";
import Header from "../../../components/header/Header";
import Footer from "../../../components/footer/Footer";
import TopButton from "../../../components/topButton/TopButton";

function GetSkillSvg(props) {
  if (props.fileName === "DataScienceImg")
    return <DataScienceImg theme={props.theme} />;
  else if (props.fileName === "FullStackImg")
    return (
      <>
        <CodeReview />
        <FullStackImg className="img" />
      </>
    );
  else if (props.fileName === "CloudInfraImg") return <CloudInfraImg />;
  return <DesignImg theme={props.theme} />;
}

class TechCareer extends Component {
  render() {
    const theme = this.props.theme;
    return (
      <div className="tech-main" id="skills">
        <Header theme={theme} />
        <div className="skills-header-div">
          <Fade bottom duration={2000} distance="20px">
            <h1 className="skills-header" style={{ color: theme.text }}>
              Tech Career Shift Guide
            </h1>
          </Fade>
        </div>
        <div>
          {articlesContent.data.map((skill, i) => {
            return (
              <div key={i} className="skills-main-div">
                <Fade left duration={2000}>
                  <div className="skills-image-div">
                    <GetSkillSvg fileName={skill.fileName} theme={theme} />
                  </div>
                </Fade>

                <div className="skills-text-div">
                  <Fade right duration={1000}>
                    <h1
                      className="skills-heading"
                      style={{ color: theme.text }}
                    >
                      {skill.title}
                    </h1>
                  </Fade>
                  <Fade right duration={1500}>
                    {Array.isArray(skill.softwareSkills) && (
                      <SoftwareSkill logos={skill.softwareSkills} />
                    )}
                  </Fade>
                  <Fade right duration={2000}>
                    <div>
                      <p
                        //key={i}
                        className="subTitle skills-text"
                        style={{ color: theme.secondaryText }}
                      >
                        {skill.description}
                      </p>
                    </div>
                    <div>
                      {skill.skills?.map((skillSentence, i) => {
                        return (
                          <p
                            key={i}
                            className="subTitle skills-text"
                            style={{ color: theme.secondaryText }}
                          >
                            {skillSentence}
                          </p>
                        );
                      })}
                    </div>
                    <div>
                      {skill.paragrapghs.map((skillSentence, i) => {
                        return (
                          <p
                            key={i}
                            className="subTitle skills-text"
                            style={{ color: theme.secondaryText }}
                          >
                            {skillSentence}
                          </p>
                        );
                      })}
                    </div>
                    <div>
                      {skill.stacks?.map((stack, index) => (
                        <div key={index} className="stack-container">
                          <h3 className="stack-title">{stack.name}</h3>
                          <p className="stack-description">
                            {stack.description}
                          </p>
                          <div className="software-skills-main-div">
                            <ul className="dev-icons">
                              {stack.logos.map((logo, i) => (
                                <li
                                  className="software-skill-inline"
                                  name={logo.name}
                                >
                                  <span
                                    className="iconify"
                                    data-icon={logo.className}
                                    data-inline="false"
                                  ></span>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      ))}
                    </div>
                  </Fade>
                </div>
              </div>
            );
          })}
        </div>
        <Footer theme={this.props.theme} onToggle={this.props.onToggle} />
        <TopButton theme={this.props.theme} />
      </div>
    );
  }
}

export default TechCareer;
